import { Translator } from '@/types/translator.type';

export const HOTEL_STEPS = (t: Translator) => [
  t('hotels.steps.configuration'),
  t('hotels.steps.roomCategoriesAndPricing'),
  t('hotels.steps.summary'),
];
